import router from '@/router'
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'
import CryptoJS from 'crypto-js'

const SECRET_KEY = 'wfmp';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:'',
    username: '',
    rol: '',
    auth: '',
    id: null,
    pais: null,
    centers: [],
    campañas: {},
    segmentos: {},
    usuarios: {},
    clientes: [],
    datosTaf: [],
    menuItems: [],

    //CANALES Y SUBCANALES
    canalesGlobales: [],
    subcanalesGlobales: []
  },
  getters: {
    getMenuItems: state => state.menuItems,
    getCenters: state => state.centers,
    getCampañas: state => state.campañas,
    getSegmentos: state => state.segmentos,
    getUsuarios: state => state.usuarios,
    getClientes: state => state.clientes,
    getDatosTaf: state => state.datosTaf,
    getAllowedRoutes: state =>
      state.menuItems.flatMap(menu =>
        menu.submenu?.map(item => item.route)
      )
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setUsername(state, username) {
      state.username = username;
    },
    setAuth(state, auth) {
      state.auth = auth;
    },
    setRole(state, rol) {
      state.rol = rol;
    },
    setId(state, id) {
      state.id = id;
    },
    setPais(state, pais) {
      state.pais = pais
    },
    set_centers(state, centers) {
      state.centers = centers;
    },
    set_campañas(state, campañas) {
      state.campañas = campañas;
    },
    set_segmentos(state, segmentos) {
      state.segmentos = segmentos;
    },
    set_usuarios(state, usuarios) {
      state.usuarios = usuarios;
    },
    set_clientes(state, clientes) {
      state.clientes = clientes;
    },

    set_datosTaf(state, datosTaf) {
      state.datosTaf = datosTaf;
    },

    setMenuItems(state, items) {
      state.menuItems = items;
    },
    logout(state) {
      //sessionStorage.removeItem('token')
      localStorage.removeItem('vuex');
      state.username = '';
      state.auth = false;
      state.rol = '';
      state.id = null;
      state.pais = null;
      state.menuItems = [];
      state.centers = [];
      state.campañas = {};
      state.segmentos = {};
      state.usuarios = {};
      state.clientes = [];
      state.datosTaf = [];
      state.canalesGlobales = [];
      state.subcanalesGlobales = [];

      router.push({ 'path': '/' }).catch(() => { });
    },

    //CANALES Y SUBCANALES
    SET_DATOS_INICIALES(state, { canales, subcanales }) {
      state.canalesGlobales = canales
      state.subcanalesGlobales = subcanales
    }
  },
  actions: {
    updateMenuItems({ commit }, items) {
      commit('setMenuItems', items);
    },
    async listCenter({ commit }) {
      try {
        const pais = this.state.pais;
        const response = await axios.get('getCenter', {
          params: { pais }
        });
        commit('set_centers', response.data);
      } catch (error) {
        console.error("Error cargando unidades de negocio:", error)
      }
    },
    async listCampañas({ commit }) {
      try {
        const pais = this.state.pais;
        const response = await axios.get('getCampañas', {
          params: { pais }
        });
        commit('set_campañas', response.data);
      } catch (error) {
        console.error("Error cargando campañas:", error)
      }
    },
    async listSegmentos({ commit }) {
      try {
        const pais = this.state.pais;
        const response = await axios.get('getSegmentos', {
          params: { pais }
        });
        commit('set_segmentos', response.data);
      } catch (error) {
        console.error("Error cargando segmentos:", error)
      }
    },
    async listUsuarios({ commit }) {
      try {
        const pais = this.state.pais;
        const response = await axios.get('getUsuarios', {
          params: { pais }
        });
        commit('set_usuarios', response.data);
      } catch (error) {
        console.error("Error cargando usuarios:", error)
      }
    },
    async listClientes({ commit }) {
      try {
        const pais = this.state.pais;
        const response = await axios.get('getClientes', {
          params: { pais }
        });
        commit('set_clientes', response.data);
      } catch (error) {
        console.error("Error cargando clientes:", error)
      }
    },
    async listDatosTaf({ commit }) {
      try {
        const datosTaf = this.state.datosTaf;
        const response = await axios.get('getDatosTarificador', {
          params: { datosTaf }
        });
        commit('set_datosTaf', response.data);
      } catch (error) {
        console.error("Error cargando datos del tarificador:", error)
      }
    },

    //CANALES Y SUBCANALES
    async listCanalesSubcanales({ commit }) {
      try {
        const res = await axios.get('getDatosMaestrosTarificador');
        commit('SET_DATOS_INICIALES', res.data);
      } catch (error) {
        console.error("Error cargando datos de canales y subcanales:", error)
      }
    }
  },
  modules: {
  },
  plugins: [
  createPersistedState({
    key: 'vuex',
    storage: {
      getItem: (key) => {
        const data = window.localStorage.getItem(key);
        if (!data) return null;
        try {
          // 1. Desencriptar el string de la base de datos
          const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
          const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
          
          // 2. Convertir el texto de vuelta a objeto JS
          return JSON.parse(decryptedText);
        } catch (e) {
          console.error("Error al desencriptar:", e);
          return null;
        }
      },
      setItem: (key, value) => {
        // value viene como objeto, CryptoJS necesita un STRING
        // 1. Convertimos el objeto state a JSON String
        const stringData = JSON.stringify(value);
        
        // 2. Encriptamos ese String
        const encryptedData = CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
        
        return window.localStorage.setItem(key, encryptedData);
      },
      removeItem: (key) => window.localStorage.removeItem(key),
    },
  }),
],
})
